<template>
  <!-- Active RouterLink -->
  <RouterLink
    v-if="button.to && button.active"
    :to="button.to"
    :class="buttonClasses"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    {{ translatedLabel }}
    <span :class="hoverLineClasses"></span>
  </RouterLink>

  <!-- Inactive RouterLink behaves like a disabled span -->
  <div v-else-if="button.to && !button.active">
    <span :class="disabledClasses">
      {{ translatedLabel }}
    </span>
    <small class="text-sm text-gray-500/40 dark:text-gray-400/20">
      {{ i18n.t("comingSoon") }}
    </small>
  </div>

  <!-- Active or inactive button -->
  <button
    v-else
    :class="[button.active ? buttonClasses : disabledClasses]"
    :disabled="!button.active"
    @click="button.action && button.active ? button.action() : null"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    {{ translatedLabel }}
    <span v-if="button.active" :class="hoverLineClasses"></span>
  </button>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { RouterLink } from "vue-router";

const isHovered = ref(false);
const i18n = useI18n();

const props = defineProps({
  button: {
    type: Object as () => {
      label: string;
      to?: string;
      active?: boolean;
      action?: () => void;
      class?: string;
    },
    required: true,
  },
});

const translatedLabel = computed(() => {
  const label = props.button.label;
  if (
    typeof label === "string" &&
    (label.startsWith("menuKeys.") || label.startsWith("legalKeys."))
  ) {
    try {
      return i18n.t(label);
    } catch (err) {
      console.warn("[FooterButton] Erro ao traduzir:", label, err);
      return label;
    }
  }
  return label;
});

const buttonClasses = computed(() => [
  props.button.class || "w-fit",
  "relative py-2 px-4 text-black dark:text-white border-b-2 border-transparent transition duration-300 ease-in-out focus:outline-none cursor-pointer",
]);

const disabledClasses = computed(() => [
  props.button.class,
  "relative py-2 px-4 text-gray-400 dark:text-gray-500 border-b-2 border-transparent cursor-default opacity-50",
]);

const hoverLineClasses = computed(() => [
  "absolute left-0 bottom-0 h-0.5 bg-black dark:bg-white transition-all duration-300 ease-in-out origin-left",
  isHovered.value ? "w-full" : "w-0",
]);
</script>
